import { apiClient } from "@lib/axios";

export const mfaApi = {
  // CREATE (POST)
  sendEmailVerificationCode: async () =>
    apiClient.post<{ sent: boolean }>("/users/mfa/email-verification/send"),
  confirmEmailVerificationCode: async (code: string) =>
    apiClient.post<{ verified: boolean }>(
      "/users/mfa/email-verification/confirm",
      { code },
    ),
};
